

































import { Component, Mixins } from 'vue-property-decorator'
import CookieConsentMixin from '../mixins/CookieConsentMixin'

@Component
export default class CookieConsent extends Mixins(CookieConsentMixin) {
  isModifyMode = false

  acceptAction () {
    this.isModifyMode ? this.accept() : this.acceptAll()
  }

  acceptAll () {
    this.changeValues([
      { key: 'analytics', value: true },
      { key: 'conversion', value: true },
      { key: 'socials', value: true }
    ])
    this.accept()
  }

  refuseAll () {
    this.changeValues([
      { key: 'analytics', value: false },
      { key: 'conversion', value: false },
      { key: 'socials', value: false }
    ])
    this.accept()
  }
}
